import Image from 'next/image';
import React from 'react';
import { ITechnologiesWeUseProps } from './interface';
import { imageSerializer } from '../../../utils/imageSerializer';
import { Icon, Icons, Inner, Title, Wrapper } from './technologiesWeUse.styles';

export const TechnologiesWeUse = ({
  title,
  icons,
  titleAs,
}: ITechnologiesWeUseProps): JSX.Element => {
  return (
    <Wrapper>
      <Inner>
        <Title as={titleAs}>{title}</Title>
        <Icons>
          {icons.map(({ icon }, index) => {
            return (
              icon!.alt &&
              icon!.alt !== 'Figma' && (
                <Icon key={index}>
                  <Image {...imageSerializer(icon!)} />
                </Icon>
              )
            );
          })}
        </Icons>
      </Inner>
    </Wrapper>
  );
};
